import React, { useEffect, useRef } from 'react';

import FadeIn from 'src/components/elements/FadeIn';

import { getMobileDevicePlatform } from 'src/helpers/common';
import usePlayVideoInPowerSaveMode from 'src/hooks/usePlayVideoInPowerSaveMode';

import { S3_IMAGES_URL, S3_MP4_URL } from '../../constants';

import styles from './MainScreen.scss';

const MainScreen = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isIos = getMobileDevicePlatform() === 'ios';

  usePlayVideoInPowerSaveMode(videoRef);

  useEffect(() => {
    const video = videoRef.current as HTMLVideoElement | null;

    if (video) {
      const replayFromSpecificTime = () => {
        video.currentTime = 8;
        video.play();
      };

      video.onended = replayFromSpecificTime;

      return () => {
        video.onended = null;
      };
    }
  }, []);

  return (
    <div className={styles.mainScreen}>
      {isIos ? (
        <img
          className={styles.mainScreenImage}
          src={`${S3_IMAGES_URL}main_screen.webp`}
          alt="main-screen"
        />
      ) : (
        <video
          ref={videoRef}
          autoPlay={true}
          preload="auto"
          muted={true}
          playsInline={true}
          className={styles.mainScreenVideo}
        >
          <source src={`${S3_MP4_URL}main_screen.mp4`} type="video/mp4" />
        </video>
      )}

      <div className={styles.title}>
        <FadeIn delay={3}>
          <span className={styles.titleThin}>Travel smart</span>
          <br />
          <span className={styles.titleThin}>with</span> Solar Cash
        </FadeIn>
      </div>
    </div>
  );
};

export default MainScreen;
